import styled from "styled-components";

const StyledForm = styled.div`
  position: relative;

  .modal-header {
    padding-bottom: 16px;
    border-bottom: 1px solid var(--color-neutral-300);
    margin-bottom: 16px;
  }

  .modal-title {
    margin: 0;
    font-size: 18px;
    font-weight: var(--font-weight-semibold);
    color: var(--color-contrast-brand);
  }

  .modal-content {
    padding-top: 4px;
  }

  .modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding-top: 16px;
    margin-top: 16px;
    border-top: 1px solid var(--color-neutral-300);
  }

  .container__general-form {
    width: 100% !important;
    padding: 8px 0 4px 0;
    margin-top: 0;
    border: none !important;
    margin-bottom: 12px;
  }

  .label-style {
    display: block;
    padding-top: 12px;
    padding-bottom: 4px;
    margin-top: 8px;
    border-top: 1px solid var(--color-neutral-300);
    color: var(--color-contrast-brand);
    font-weight: var(--font-weight-semibold);
    font-size: 14px;
  }

  .auto-complete {
    width: 100%;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .auto-complete-configuracoes {
    width: 100%;
    margin-top: 6px;
    margin-bottom: 6px;
  }

  ::-webkit-inner-spin-button {
    display: none;
  }

  .span-message {
    display: contents;
    align-content: left;
    font-size: 14px;
    float: right;
    color: #e8b007;
  }

  .span-message-container {
    margin-top: -8px;
  }

  .toogleVolumesPendentes {
    padding-top: 8px;
    padding-bottom: 10px;
  }

  .daily-wallet {
    display: flex;
    align-items: flex-end;
  }

  .daily-wallet-settings{
    margin-top: 16px !important;
  }

  .bulk-pending {
    margin-bottom: 8px;
  }

  .input-legend {
    padding-top: 2px;
    color: var(--color-contrast-brand);
    font-size: 10px;
    display: flex;
    justify-content: end;
  }

  .row-box{
    margin-bottom: 10px;
  }

  .sl-selectbox-section{
    margin-top: -10px;
    margin-bottom: 10px;
  }

  .message-sl-configuration {
    margin-top: 14px;
    margin-bottom: 16px;
    text-align: center;
    color: var(--color-feedback-danger-300);
  }
`;
export default StyledForm;
